package fr.manyverse.app.presentation.components.modules.common

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.FilterChip
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import fr.manyverse.app.domain.model.TableMember
import fr.manyverse.app.presentation.components.CheckboxRow
import manyverse.shared.generated.resources.Res
import manyverse.shared.generated.resources.module_all_participants
import manyverse.shared.generated.resources.module_participants
import org.jetbrains.compose.resources.stringResource

sealed class ParticipantSelectionMode {
    data class Single(
        val selectedId: String,
        val onSelect: (String) -> Unit
    ) : ParticipantSelectionMode()

    data class Multiple(
        val selectedIds: Set<String>,
        val allSelected: Boolean,
        val onToggle: (String) -> Unit,
        val onToggleAll: () -> Unit
    ) : ParticipantSelectionMode()
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
fun ParticipantSelector(
    players: List<TableMember>,
    mode: ParticipantSelectionMode,
    labelOf: (TableMember) -> String = { it.userId.take(8) },
    isEnabled: Boolean = true,
    modifier: Modifier = Modifier
) {
    Column(modifier = modifier) {
        Text(
            text = stringResource(Res.string.module_participants),
            style = MaterialTheme.typography.labelMedium
        )

        when (mode) {
            is ParticipantSelectionMode.Single -> {
                FlowRow(
                    horizontalArrangement = Arrangement.spacedBy(4.dp),
                    modifier = Modifier.padding(top = 8.dp)
                ) {
                    players.forEach { player ->
                        FilterChip(
                            selected = player.userId == mode.selectedId,
                            onClick = { mode.onSelect(player.userId) },
                            label = { Text(labelOf(player)) },
                            enabled = isEnabled
                        )
                    }
                }
            }

            is ParticipantSelectionMode.Multiple -> {
                CheckboxRow(
                    label = stringResource(Res.string.module_all_participants),
                    checked = mode.allSelected,
                    onCheckedChange = { mode.onToggleAll() },
                    enabled = isEnabled,
                    modifier = Modifier.padding(top = 8.dp)
                )
                if (players.isNotEmpty()) {
                    FlowRow(
                        horizontalArrangement = Arrangement.spacedBy(4.dp),
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(top = 4.dp)
                    ) {
                        players.forEach { player ->
                            FilterChip(
                                selected = mode.allSelected || player.userId in mode.selectedIds,
                                onClick = { mode.onToggle(player.userId) },
                                label = { Text(labelOf(player)) },
                                enabled = isEnabled
                            )
                        }
                    }
                }
            }
        }
    }
}
